import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { apiResources } from '../api/api.resources';
import {
    NotificationInterface,
    NotificationsQueryInterface,
    NotificationsResponseInterface,
    UnreadCountResponseInterface
} from './notifications.interface';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    private readonly NOTIFICATIONS_BASE = environment.config.apiUrl + apiResources.v1 + apiResources.notifications.base;

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    /**
     * Lista paginada de notificações com filtros opcionais.
     * Query params do contrato: page, category, type, read.
     * `per_page` NÃO é enviado (padrão canônico movements/entries) — o backend
     * usa default fixo 20 no repository.
     */
    getNotifications(query: NotificationsQueryInterface): Observable<NotificationsResponseInterface> {
        const params: Record<string, string> = {
            page: String(query.page),
        };

        if (query.category) {
            params['category'] = query.category;
        }

        if (query.type) {
            params['type'] = query.type;
        }

        if (query.read !== undefined && query.read !== null) {
            params['read'] = String(query.read);
        }

        return this._httpClient.get<NotificationsResponseInterface>(this.NOTIFICATIONS_BASE, { params });
    }

    getUnreadCount(): Observable<UnreadCountResponseInterface> {
        return this._httpClient.get<UnreadCountResponseInterface>(this.NOTIFICATIONS_BASE + apiResources.notifications.unreadCount);
    }

    markAsRead(id: number): Observable<any> {
        return this._httpClient.put(this.NOTIFICATIONS_BASE + '/' + id + apiResources.notifications.read, {});
    }

    markAllAsRead(): Observable<any> {
        return this._httpClient.put(this.NOTIFICATIONS_BASE + apiResources.notifications.readAll, {});
    }
}